<template>
  <evaluate-container :list="questions" :answers="answers" :all="all" :tree="tree" :is-view="isView" :role="role" :info="info" :find-answer="findAnswer" :node-click="handleNodeClick">
    <template v-slot:default="{list, forms, current, currentForm, currentIndex, indexChange, upload, down}">
      <el-form ref="form" :model="currentForm" :rules="rules">
        <h2>{{ current.name }}</h2>
        <div class="flex flex-col xl:flex-row md:space-x-5" v-if="currentForm.quesId && current.question">
          <div class="xl:w-1/2 flex flex-col space-y-20 flex-none" :class="[1, 4, 6, 7, 8, 9, 10, 11, 14, 15].includes(current.question.i) ? 'xl:w-3/4' : ''">
            <div class="flex flex-none space-x-2 justify-between">
              <div>
                <h2><span v-if="current.question.status === 1">(多选)</span>{{ current.question.name }}</h2>
                <el-form-item prop="ans">
                  <el-checkbox-group v-if="current.question.status === 1" size="mini" v-model="currentForm.ans" @change="(val) => handleCheckChange(val, currentForm, current)">
                    <el-col :span="24">
                      <el-checkbox class="answer-item" :label="item.id" v-for="item in current.question.children" :key="item.id">{{item.name}}</el-checkbox>
                    </el-col>
                  </el-checkbox-group>
                  <el-radio-group v-else size="mini" v-model="currentForm.ans" @change="(val) => handleRadioChange(val, currentForm, current)">
                    <el-radio v-show="!(current.question.i === 8 && i === current.question.children.length - 1)" class="answer-item" v-for="(item, i) in current.question.children" :key="item.id" :label="item.id">{{item.name}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
            <div class="justify-self-end">
              <el-button :disabled="currentIndex === 0" @click="indexChange(currentIndex - 1)">回到上一题</el-button>
              <el-button v-if="!isView" @click="handleSave(currentForm, current, forms)" :disabled="currentForm.saved">保存</el-button>
              <el-button :disabled="currentIndex + 1 === questions.length" @click="indexChange(currentIndex + 1)">进入下一题</el-button>
              <el-button v-if="currentIndex + 1 === questions.length" @click="handleChangeType">进入场景环节</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </template>
  </evaluate-container>
</template>

<script>
import EvaluateContainer from '@/views/proposal/partials/EvaluateContainer'
import { addOwnerAnswer as addAnswer } from '@/api/enterprise'

export default {
  props: ['info', 'questions', 'answers', 'all', 'tree', 'isView', 'role', 'mode'],
  components: { EvaluateContainer },
  data () {
    return {
      rules: {
        ans: { required: true, message: '请选择选项', trigger: 'blur' },
        fileIds: { required: true, message: '佐证材料不能为空', trigger: 'blur' },
        remark: { required: true, message: '谰审意见不能为空', trigger: 'blur' }
      },
      pivotForm: {}
    }
  },
  methods: {
    findAnswer (v) {
      const item = this.answers.find(a => a.quesId * 1 === v.question.id * 1) || { quesId: v.question.id * 1, ans: v.question.status * 1 === 0 ? '""' : '[]', fileIds: '[]', version: 1, otherAns: '{}' }
      return Object.assign({}, item, { ans: JSON.parse(item.ans), otherAns: JSON.parse(item.otherAns), fileIds: JSON.parse(item.fileIds) })
    },
    handleRadioChange (val, currentForm, current) {
      const nonItem = current.question.children.find(v => v.name.trim() === '无')
      currentForm.nonCheck = nonItem && val === nonItem.id
      currentForm.saved = false
    },
    handleCheckChange (val, currentForm, current) {
      const nonItem = current.question.children.find(v => v.name.trim() === '无')
      if (nonItem && val.includes(nonItem.id)) {
        currentForm.ans = [nonItem.id]
        currentForm.nonCheck = true
      } else {
        currentForm.nonCheck = false
      }
      currentForm.saved = false
    },
    handleSave (currentForm, current, forms) {
      Promise.all([
        Promise.resolve()
      ]).then(() => {
        const data = {
          quesId: currentForm.quesId,
          ans: JSON.stringify(currentForm.ans),
          fileIds: JSON.stringify(currentForm.fileIds),
          otherAns: JSON.stringify(currentForm.otherAns),
          userId: this.info.userId,
          version: 1
        }
        addAnswer(data).then(res => {
          this.$set(currentForm, 'id', res.data.id)
          currentForm.saved = true
          this.$message.success('保存成功！')
          this.$emit('save', res.data)
        })
      }).catch(() => {})
    },
    handleNodeClick (node) {
      if (node.level === 3) {
        return this.questions.findIndex(v => v.id === node.id)
      } else return -1
    },
    handleChangeType () {
      this.$emit('change-type', 'scene')
    }
  }
}
</script>
